import { CollectionStatusEnum } from "@kanpla/api-contract";
import { devtools } from "zustand/middleware";
import { createStore } from "zustand/vanilla";

import { type CollectStore } from "./store.types";

const INITIAL_STATE: CollectStore = {
  orderLines: [],
  successInfo: null,
  flow: "pos",
  statusFilter: CollectionStatusEnum.IN_PROGRESS,
  groupPrimary: null,
  groupSecondary: null,
  searchBy: "firstName",
  selectedLetter: null
};

const collectStore = createStore<CollectStore>()(
  devtools(() => INITIAL_STATE, { name: "collect-store" })
);

export { INITIAL_STATE, collectStore };
